














import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { IndexBar, IndexAnchor, Cell, Search } from "vant";
import * as _ from "lodash";
import dataShare from "@/views/mall/dataShare";
import UserService from "@/service/UserService";
import { RoleInfoEntity } from "../../../model/system";
import { fromPairs, values } from "lodash";
import { RoleType } from "@/model/Base";

@Component({
  name: "chooseCostCenter",
  components: {
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [Search.name]: Search,
  },
})
export default class extends Vue {
  selected = "";
  keywords = "";
  dataShare = dataShare;

  get options() {
    return this.dataShare.costCenters;
  }

  // mounted
  mounted() {
    this.CostCenters = dataShare.costCenters;
    // this.getOwnerConferList();
  }
  CostCenters: any = [];
  OwnerCostCenter: any = [];
  filterCenter(costCenter: any) {
    // let __self = this;
    // var str = "";
    // __self.OwnerCostCenter.forEach((o: any) => {
    //   if (o.OwnerID == costCenter.RoleID) {
    //     str += o.RoleName + ",";
    //   }
    // });
    // if (str) {
    //   return `${costCenter.RoleName}(${str.substring(str.length - 1, -1)})`;
    // }
    return costCenter.RoleName;
  }
  // getOwnerConferList() {
  //   let __self = this;
  //   let RoleIDs: any = [];
  //   dataShare.consumers.forEach((o: any) => {
  //     RoleIDs.push(o.ConsumerID);
  //   });
  //   let data = {
  //     PageSize: 999999,
  //     RoleIDs: RoleIDs,
  //     RoleWith: RoleType.User,
  //     OwnerWith: RoleType.CostCenter,
  //     SpaceID: __self.profile.CompanyID,
  //   };
  //   UserService.getConferList(data).then((json: any) => {
  //     if (!json.isSucc || !json.result) {
  //       return;
  //     }
  //     __self.OwnerCostCenter = _.orderBy(json.result.entities, ["UpdateTime"], ["desc"]);
  //     __self.OwnerCostCenter.forEach((o: any, i: any) => {
  //       __self.CostCenters.forEach((m: any, index: any) => {
  //         if (o.OwnerID == m.RoleID) {
  //           __self.CostCenters.splice(index, 1);
  //           __self.CostCenters.unshift(m);
  //         }
  //       });
  //     });
  //   });
  // }

  select(value: string) {
    this.dataShare.costCenter = value;
    this.back();
  }

  back() {
    history.back();
  }
  get filterOptions() {
    let __self = this;
    if (this.keywords != "") {
      let searchList = _.filter(__self.options, (o: any) => o.RoleName.indexOf(this.keywords) > -1);
      return _.uniq(searchList);
    }
    return __self.options;
  }
}
